import { render, staticRenderFns } from "./ItemCopyInterface.vue?vue&type=template&id=35e0f829"
import script from "./ItemCopyInterface.vue?vue&type=script&lang=js"
export * from "./ItemCopyInterface.vue?vue&type=script&lang=js"
import style0 from "./ItemCopyInterface.vue?vue&type=style&index=0&id=35e0f829&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports